<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title">Remove Question</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>The question will be removed, and all answers to this question in the platform reports will also be removed.</p>
      <div class="form__btn d-flex">
        <b-button type="submit" class="mx-auto btn-image mt-4" @click="$store.dispatch('closeModal', true)">
          <span>Cancel</span>
        </b-button>
        <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" @click="remove()">
          <span>Remove</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

  export default {
    name: 'ModalSection',
    computed: {
      ...mapGetters([
        'getQuestionToRemove',
      ]),
    },
    methods: {
      ...mapActions([
        'destroyQuestion'
      ]),
      remove() {
        console.log(this.getQuestionToRemove)
        if (this.getQuestionToRemove) this.destroyQuestion([this.getQuestionToRemove])
      }
    }
  }
</script>

<style scoped>

</style>